// extracted by mini-css-extract-plugin
module.exports = {"container":"CloseModal_container__DI7iJ"};